import type * as ecModels from '../../../../models'

import type { Group } from './group'

// TODO: clean up and document

export type GroupSelection<TTypeParams extends ecModels.TypeParams.Constraint> =
  ExactlyOneOf<
    GroupSelection.ForIdentifier & GroupSelection.ForObject<TTypeParams>
  >
export namespace GroupSelection {
  export type Normalized = readonly Group.Id[]
  export function normalize({
    group,
    groups,
    groupId,
    groupIds,
  }: GroupSelection<any>): Normalized {
    if (group) {
      groupIds = [group.id]
    }
    if (groups) {
      groupIds = groups.map(_group => _group.id)
    }
    if (groupId) {
      groupIds = [groupId]
    }

    return groupIds ?? []
  }

  export type ForObject<TTypeParams extends ecModels.TypeParams.Constraint> =
    ExactlyOneOf<{
      readonly group: Group<TTypeParams>
      readonly groups: readonly Group<TTypeParams>[]
    }>
  export namespace ForObject {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export type Normalized<TTypeParams extends ecModels.TypeParams.Constraint> =
      readonly Group<TTypeParams>[]
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export function normalize<
      TTypeParams extends ecModels.TypeParams.Constraint,
    >(value: ForObject<TTypeParams>): Normalized<TTypeParams> {
      return value.groups ?? [value.group]
    }
  }
  export type ForIdentifier = ExactlyOneOf<{
    readonly groupId: Group.Id
    readonly groupIds: readonly Group.Id[]
  }>
  export namespace ForIdentifier {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export type Normalized = readonly Group.Id[]
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export function normalize(value: ForIdentifier): Normalized {
      return value.groupIds ?? [value.groupId]
    }
  }
}
